var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#building_svg__filter0_d_1850_5280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30.5,
    r: 30,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.667 17.166c.736 0 1.333.598 1.333 1.334v24a1.333 1.333 0 11-2.667 0V19.833h-8V42.5a1.333 1.333 0 11-2.666 0V31.833h-8V42.5a1.333 1.333 0 01-2.667 0v-12c0-.736.597-1.334 1.333-1.334h9.334V18.5c0-.736.597-1.334 1.333-1.334h10.667zM40 22.5c.736 0 1.333.597 1.333 1.333v1.334c0 .736-.597 1.333-1.333 1.333h-1.333a1.333 1.333 0 01-1.334-1.334v-1.333c0-.736.597-1.333 1.334-1.333H40zm1.333 8c0-.736-.597-1.334-1.333-1.334h-1.333c-.737 0-1.334.598-1.334 1.334v1.333c0 .736.597 1.334 1.334 1.334H40c.736 0 1.333-.598 1.333-1.334V30.5zM40 35.833c.736 0 1.333.597 1.333 1.334V38.5c0 .736-.597 1.333-1.333 1.333h-1.333a1.333 1.333 0 01-1.334-1.333v-1.334c0-.736.597-1.333 1.334-1.333H40zM29.333 34.5c.737 0 1.334.597 1.334 1.333v1.334c0 .736-.597 1.333-1.334 1.333H28a1.333 1.333 0 01-1.333-1.334v-1.333c0-.736.597-1.333 1.333-1.333h1.333z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "building_svg__filter0_d_1850_5280",
    x: 0,
    y: 0.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1850_5280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1850_5280",
    result: "shape"
  })))));
}
export default SvgBuilding;